// Brand assets — Wellness Way with DJ
export const ASSETS = {
  logo: "https://customer-assets.emergentagent.com/job_coach-connect-hub-2/artifacts/yotpn0t5_White%20logo%20WW.png.png",
  brandedBodysuit: "https://customer-assets.emergentagent.com/job_coach-connect-hub-2/artifacts/c5txtxqw_Neutral%20Minimal%20Lifestyle%20Quote%20Social%20Media%20Post.png",
  authorityCamel: "https://customer-assets.emergentagent.com/job_coach-connect-hub-2/artifacts/jfs2aqaw_Copy%20of%20G1-L03-R9x16-50-2%20%281%29.png",
  monogramDark: "https://customer-assets.emergentagent.com/job_coach-connect-hub-2/artifacts/m1xbvvfb_W%20%281%29.png",
  organicLinen: "https://customer-assets.emergentagent.com/job_coach-connect-hub-2/artifacts/vtjpcako_Untitled%20design%20%2846%29.png",
  mtmCover: "https://customer-assets.emergentagent.com/job_coach-connect-hub-2/artifacts/eb1z0mz8_Pink%20and%20Peachy%20Minimalistic%20Fashion%20New%20Collection%20Flyer.png",
};

export const PHOTOS = {
  athleticYoga:     "/photos/img_3327.jpg",
  athleticBack:     "/photos/img_3331.jpg",
  bodysuitKneel:    "/photos/img_3339.jpg",
  bodysuitSquat:    "/photos/img_3343.jpg",
  editorialBW:      "/photos/img_3359.jpg",
  bodysuitGaze:     "/photos/img_3362.jpg",
  authoritySuit:    "/photos/img_3366.jpg",
  authorityStool:   "/photos/img_3383.jpg",
  organicProfile:   "/photos/img_3395.jpg",
};

export const TRANSFORMATIONS = [
  {
    src: "/photos/wins/4.jpg",
    name: "Tiffany",
    condition: "Insulin resistance · low energy",
    results: ["Healed insulin & metabolic resistance", "Lowered inflammation", "Reclaimed energy", "Lost 5 lb · full body recomp", "Lost body fat, built lean muscle"],
  },
  {
    src: "/photos/wins/5.jpg",
    name: "Nikki",
    condition: "Metabolic resistance · felt lost",
    results: ["Increased insulin sensitivity", "Dropped 20+ lbs", "Regained energy", "Gained lifelong knowledge she still uses today"],
  },
  {
    src: "/photos/wins/6.jpg",
    name: "Paige",
    condition: "Insulin resistance · fatigue · inflammation",
    results: ["Dropped several inches", "Lost 10+ lbs", "Gained energy", "No longer caffeine dependent", "All in just a couple months"],
  },
  {
    src: "/photos/wins/7.jpg",
    name: "Brianna",
    condition: "Extreme fatigue · mood swings · weight-loss resistance",
    results: ["Lost 20+ lbs in 12 weeks", "Gained energy & strength", "Back in her 'skinny' clothes", "More present with her family"],
  },
  {
    src: "/photos/wins/8.jpg",
    name: "Amber",
    condition: "Constant bloating · feeling weak",
    results: ["Dropped bloating & inflammation", "Lost 10 lbs", "Gained lean muscle & strength"],
  },
  {
    src: "/photos/wins/9.jpg",
    name: "Bri",
    condition: "Needed a reset",
    results: ["Detox protocol results in 3 weeks", "Dropped inches and weight", "Regained energy"],
  },
];

export const TESTIMONIALS = [
  {
    name: "Nikie",
    role: "Stay-at-home mom · PCOS",
    body:
      "A busy stay-at-home mom with PCOS — exhausted, struggling with weight loss, unable to stick to a routine. When life called her back to her nursing career, she still reversed her symptoms and finally dropped the weight she had carried for years.",
  },
  {
    name: "Tiffany",
    role: "Single mom · business owner",
    body:
      "Single mom and business owner who overcame insulin resistance, regained her natural energy, transformed her body and metabolism, and gained the knowledge to keep her results sustainable for life.",
  },
];

export const BRAND = {
  name: "Wellness Way",
  tag: "with DJ",
  fullName: "Wellness Way with DJ",
  handle: "@wellnesswaywithdj",
  tagline: "Elegant · Organic · Athletic · Transformational",
  calendlyUrl: "https://calendly.com/djheningerfitness/mtmstrategycall",
  everfitUrl: "https://invite.everfit.io/onboarding/KJKOEGW8TP",
};

// DJ's founder story — extracted from her MTM VSL script
export const FOUNDER_STORY = {
  credentials: "Certified Hormone Health Coach · Functional Health Coach · Elite Personal Trainer",
  hook: "I was once exactly where you are.",
  paragraphs: [
    "Even with my background in personal training and sports nutrition, I was lost, ashamed, and hopeless when my body changed on me — almost overnight — when I turned 30.",
    "Nothing that worked before worked anymore. Low-carb diets, HIIT, two-a-days — they left me craving sugar, exhausted, inflamed, and gaining weight no matter what I did.",
    "It wasn't until I discovered functional health — the role of hormones and gut health — that I realized the key wasn't pushing harder. It was healing.",
    "I dove into functional nutrition and hormone science to repair my own metabolism. Then I built the Metabolic Transformation Method to walk other women through the exact same restoration.",
  ],
};

// The two flagship offerings
export const PROGRAMS = {
  mtm: {
    key: "mtm",
    title: "Metabolic Transformation Method",
    short: "MTM",
    type: "Group · Evergreen",
    duration: "24 Weeks · 6 Months",
    tagline: "A scientifically-backed, hormone-informed program to repair your metabolism — for life.",
    description:
      "The signature group program. Six months. Four phases. Built to rewire how your body responds to fat loss, restore your sleep, remove the cravings, and walk you into a life of balance without extremes.",
    cta: "Book a strategy call",
    featured: true,
    phases: [
      {
        name: "Detox",
        weeks: "Weeks 1–4",
        focus:
          "Not a starve-you juice cleanse. A researched, science-backed protocol that leaves you full, nourished, and energized — while detoxing at a cellular level and dropping the inflammation that's making your body resistant to change.",
        themes: ["Cellular detox", "Foundational habits", "Nervous system", "Inflammation"],
      },
      {
        name: "Restore",
        weeks: "Weeks 5–8",
        focus:
          "We phase out of detox and focus on healing the gut, balancing blood sugar, lowering cortisol, and restoring the metabolism — so your body feels safe enough for the next phase.",
        themes: ["Gut healing", "Blood sugar", "Cortisol", "Metabolic safety"],
      },
      {
        name: "Burn",
        weeks: "Weeks 9–20",
        focus:
          "Your body is out of survival and balanced. Now we move into a dialed-in protocol for strategic fat loss — losing body fat, keeping the muscle, that lean, toned, beautiful look.",
        themes: ["Strategic fat loss", "Strength", "Body composition", "Identity shift"],
      },
      {
        name: "Reset",
        weeks: "Weeks 21–24",
        focus:
          "This phase is NEVER skipped. We reverse diet to maintain your results, phase out of deficit, and walk you into a balanced, thriving life without guilt or extremes. The whole point — sustainability.",
        themes: ["Reverse dieting", "Metabolic freedom", "Long-term integration"],
      },
    ],
    pillars: [
      { name: "Mind", body: "Emotional regulation, identity, mindset, nervous system." },
      { name: "Body", body: "Functional nutrition, metabolic strength, anti-inflammatory movement." },
      { name: "Soul", body: "Self-awareness, self-compassion, integration, ceremony." },
    ],
    includes: [
      "Weekly group coaching calls",
      "Phase-specific training & nutrition programming",
      "Supplement protocols",
      "Phase guidebooks & recipe books",
      "Private community forum",
      "Habit check-offs & progress tracking",
      "Weekly Mind · Body · Soul prompts",
      "Cycle syncing & training-adjustment guide",
      "Graduation ceremony workbook",
    ],
    investment: {
      headline: "An investment in the rest of your life.",
      framing:
        "Nutritionists average $200 per visit. Personal trainers, $100 per session — about $800 a month for twice a week. Hormone specialists, $500–$1,000 per month. MTM is everything, together, for less than the cost of one of them alone.",
      earlyBird: "Six months for the price of four — this round only.",
      tiers: [
        {
          name: "Paid in full",
          price: "$1,800",
          per: "for the 6 months",
          subtitle: "Best value · $5 a day",
          highlight: true,
          savings: "Save $150 vs. 3-pay",
          cta: "Enroll · Pay in full",
          stripe_url: "https://buy.stripe.com/28E4gy4Kv3ydbkdfpO8N20a",
        },
        {
          name: "2 payments",
          price: "$950",
          per: "every 3 months",
          subtitle: "Total $1,900",
          highlight: false,
          savings: "Save $50 vs. 3-pay",
          cta: "Book a call",
          stripe_url: "",
        },
        {
          name: "3 payments",
          price: "$650",
          per: "every 2 months",
          subtitle: "Total $1,950",
          highlight: false,
          savings: "Flexible monthly cadence",
          cta: "Book a call",
          stripe_url: "",
        },
      ],
      footnote:
        "Payment plans run through Stripe. Discuss the right path for you on the strategy call.",
    },
  },
  riseWithin: {
    key: "rise-within",
    title: "Rise Within",
    short: "Rise Within",
    type: "1:1 Coaching",
    duration: "Bespoke",
    tagline: "Fully hands-on private coaching — lab testing, custom protocols, deep work.",
    description:
      "For the woman who wants me in her corner, weekly. Functional lab testing, fully customized protocols, weekly check-ins, and direct access. The elite tier — limited spots, by application only.",
    cta: "Apply for 1:1",
    featured: false,
    includes: [
      "Functional lab testing (HTMA, hormones, gut, bloodwork)",
      "Fully customized nutrition & training protocols",
      "Weekly 1:1 check-ins with DJ",
      "Direct in-app messaging with DJ",
      "Custom supplement, sleep & nervous system protocols",
      "Real-time program adjustments based on biofeedback",
      "All MTM program resources included",
    ],
  },
};

// Pain-point hooks from the VSL — used on landing "Maybe you're here because..."
export const PAIN_HOOKS = [
  "Your metabolism feels sluggish — what worked in your 20s and 30s suddenly doesn't.",
  "You're doing hours of cardio, eating 1,200 calories or less, and the scale won't budge.",
  "You're stuck in cycles of yo-yo dieting, binge eating, or shame around a sweet tooth you can't kick.",
  "You've lost the motivation — and you're not sure who you are without the next diet.",
];
